<div class="mat-headline-5">{{ "ONSIP_I18N.PURCHASE_HISTORY" | translate }}</div>
<onsip-loading-container [deferCond]="isDataObtained$">
  <div class="filters-wrapper" onsip-grid-placement-shell-navigation>
    <mat-form-field appearance="outline" class="transactions-filter">
      <mat-select [formControl]="filterForm">
        <mat-option value="all">All transactions</mat-option>
        <mat-option value="plan">Plan invoices</mat-option>
        <mat-option value="pstn">PSTN transactions</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="date-filter">
      <mat-label>Filter by date</mat-label>
      <mat-select [formControl]="monthForm">
        <mat-option [value]="{ month: undefined, year: undefined }">All time</mat-option>
        @for (option of monthOptions | async; track option) {
        <mat-option [value]="option">{{ months[option.month - 1] }} {{ option.year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="generate-pdf-btn-wrapper">
      <button
        onsip-header-secondary-action
        mat-stroked-button
        color="primary"
        (click)="generateCompletePDF()"
        [disabled]="transactionHistoryData.length === 0"
      >
        <mat-icon>print</mat-icon>&nbsp;{{ "ONSIP_I18N.PRINT_PAGE" | translate }}
      </button>
    </div>
  </div>
  <div class="table-wrapper" onsip-grid-placement-shell-navigation>
    <div class="table-wrapper-container">
      @if (tableLoaded$ | async) {
      <onsip-table-two
        class="transaction-table"
        [dataSource]="dataSource"
        multiTemplateDataRows
        [hoverable]="true"
        [useGrid]="true"
        [trackBy]="trackById"
      >
        @for (column of displayedColumns; track column) {
        <ng-container matColumnDef="{{ column }}">
          <mat-header-cell *matHeaderCellDef>
            {{ column !== "actions" ? column : "" }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="table-cell">
            @if (column === 'date') {
            <span class="text-ellipsis">
              {{ row[column] | date : "mediumDate" }}
            </span>
            } @if (column !== 'actions' && column !== 'date') {
            <div class="wrapper text-ellipsis">
              <div class="text-ellipsis">{{ row[column] }}</div>
              @if ((lessThanMediumBreakpoint | async) && column === 'description') {
              <div class="text-ellipsis">
                {{ row["amount"] }}
              </div>
              }
            </div>
            } @if (column === 'actions') {
            <div class="controls-wrapper">
              @if (!expandedRows.includes(row)) {
              <mat-icon color="primary">expand_more</mat-icon>
              } @if (expandedRows.includes(row)) {
              <mat-icon color="primary">expand_less</mat-icon>
              }
            </div>
            }
          </mat-cell>
        </ng-container>
        }
        <!-- expanded -->
        <ng-container matColumnDef="expanded">
          <onsip-table-shelf-cell
            *matCellDef="let element"
            [expanded]="expandedRows.includes(element)"
          >
            <div class="expanded-shelf-wrapper">
              <onsip-table-two
                class="expanded-table"
                [dataSource]="getRowData(element)"
                multiTemplateDataRows
                [useGrid]="true"
                [ngClass]="{ pstn: element.type === 'pstn' }"
              >
                @for (column of getDisplayColumns(element); track column; let i = $index) {
                <ng-container matColumnDef="{{ column }}">
                  <mat-header-cell *matHeaderCellDef class="mat-header-cell-wrapper">
                    {{
                      column !== "empty" && column !== "pstn amount"
                        ? column === "quantity" && (isMedium$ | async)
                          ? column.slice(0, 4)
                          : column
                        : ""
                    }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="mat-cell-content-wrapper">
                    @if (column === 'service' && row.bullets && row.bullets.length > 0) {
                    <div class="text-ellipsis cell-content">
                      <div class="text-ellipsis">{{ row.service }}</div>
                      <ul>
                        @for (bullet of row.bullets; track bullet) {
                        <li>
                          <div class="text-ellipsis">{{ bulletInformation(bullet, element) }}</div>
                        </li>
                        }
                      </ul>
                    </div>
                    } @else {
                    <div class="text-ellipsis cell-content">
                      <div class="text-ellipsis">{{ getRowCellData(row, column) }}</div>
                    </div>
                    }
                  </mat-cell>
                  <mat-footer-cell class="mat-body-1 footer-call" *matFooterCellDef>
                    {{
                      i === 0
                        ? "TOTAL"
                        : i === getDisplayColumns(element).length - 1
                        ? element.amount
                        : ""
                    }}
                  </mat-footer-cell>
                </ng-container>
                }
                <mat-header-row
                  class="inner-mat-header-row"
                  *matHeaderRowDef="getDisplayColumns(element)"
                ></mat-header-row>
                <mat-row
                  class="inner-mat-row"
                  *matRowDef="let row; columns: getDisplayColumns(element)"
                ></mat-row>
                <mat-footer-row
                  class="inner-mat-footer-row"
                  *matFooterRowDef="getDisplayColumns(element)"
                ></mat-footer-row>
              </onsip-table-two>
              <div onsip-grid-placement-shelf class="expanded-controls">
                <div class="page-controls-wrapper">
                  <button mat-button color="primary" class="close-btn" (click)="expandedRows = []">
                    {{ "ONSIP_I18N.CLOSE" | translate }}
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    class="print-btn"
                    (click)="generateRowPDF(element)"
                  >
                    {{ "ONSIP_I18N.PRINT" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </onsip-table-shelf-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="
            expandedRows.includes(row)
              ? expandedRows.splice(expandedRows.indexOf(row), 1)
              : expandedRows.push(row)
          "
          [class.expanded-row]="expandedRows.includes(row)"
        ></mat-row
        >> <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>>
        <div *matNoDataRow class="no-data-row">
          {{ "ONSIP_I18N.NO_RESULTS" | translate }}
        </div>
      </onsip-table-two>
      }
    </div>
  </div>
</onsip-loading-container>
<mat-paginator
  #paginator
  [length]="dataSource.data.length"
  [pageSize]="pageLength"
  [pageSizeOptions]="pageSizeOptions"
  class="page-paginator"
  onsip-mat-paginator-shelf-navigation
  showFirstLastButtons="true"
  onsip-paginator-primary-icon
>
</mat-paginator>
